import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PrincipalService } from '../../core/security/authentication/principal.service';

@Directive({
  selector: '[hasAnyAuthority]'
})
export class HasAnyAuthorityDirective {
  private authorities: string[];

  @Input() set hasAnyAuthority(value: string | string[]) {
    if (value || (value instanceof Array && value.length > 0)) {
      this.authorities = typeof value === 'string' ? [<string>value] : <string[]>value;
    } else {
      this.authorities = undefined;
    }

    this.updateView();
    // Get notified each time authentication state changes.
    this.principal.authenticationChanges$().subscribe(identity => this.updateView());
  }
  constructor(
    private principal: PrincipalService,
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef
  ) {}

  private updateView(): void {
    this.viewContainerRef.clear();

    if (!this.authorities || this.principal.hasAnyAuthority(this.authorities)) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }
}
